import {
  PaymentTransfersNestedQuery,
  PaymentsDataCollectionQuery,
} from 'generated/resources/graphql'

import type { MappedTransferChild } from './usePaymentNestedTransfers'

export type PaymentBase =
  PaymentsDataCollectionQuery['banking']['paymentsConnection']['edges'][number]['node']

export type Payment = PaymentBase | MappedTransferChild

export type TransferNode = NonNullable<
  NonNullable<PaymentTransfersNestedQuery['banking']['transfersConnection']['edges']>[number]
>['node']

/**
 * Type guard to check if an item is a PaymentBase (not a transfer)
 */
export function isPaymentBase(item: Payment): item is PaymentBase {
  return !('_isTransfer' in item) || !item._isTransfer
}
